// Copyright (c) Microsoft Corporation. All rights reserved.
/**
 * Low bandwidth status changed event.
 */
export class LowBandwidthStatusChangedEvent extends Event {
    constructor() {
        super(LowBandwidthStatusChangedEvent.type);
    }
}
LowBandwidthStatusChangedEvent.type = 'lowBandwidthStatusChanged';
//# sourceMappingURL=LowBandwidthStatusChangedEvent.js.map